import { Flex, Link, Icon } from '@chakra-ui/react';
import { CustomPlusIcon } from '../../../theme/icons/CustomPlusIcon';

const AddMoreButton = ({
  onClick,
  text,
  isDisabled = false,
}: {
  onClick: () => void;
  text: string;
  isDisabled?: boolean;
}) => {
  return (
    <Flex alignItems="center" gap={2}>
      <Link
        color="#243744"
        onClick={isDisabled ? undefined : onClick}
        opacity={isDisabled ? 0.5 : 1}
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        _hover={{ textDecoration: 'none', opacity: isDisabled ? 0.5 : 0.8 }}
      >
        <Flex alignItems="center" gap={2} fontSize="16px">
          <Icon as={CustomPlusIcon} boxSize="16px" />
          {text}
        </Flex>
      </Link>
    </Flex>
  );
};

export default AddMoreButton;
